<mat-card class="frame" [class.is-top]="isTop()">
  <div class="labels" *ngIf="isTop()">
    <div class="label like" [style.opacity]="likeStrength()">LIKE</div>
    <div class="label nope" [style.opacity]="nopeStrength()">NOPE</div>
  </div>

  <div class="photo" [style.backgroundImage]="'url(' + currentPhotoUrl() + ')'">
    <div class="photo-scrim">
      <div class="dots" *ngIf="photoCount() > 1">
        <span class="dot" *ngFor="let active of photoDots()" [class.active]="active"></span>
      </div>
      <div class="profile-text">
        <div class="title">
          <span class="name">{{ profile.name }}</span>
          <span class="age">{{ profile.age }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="details">
    <p class="bio">{{ profile.bio }}</p>

    <dl class="facts">
      <div class="fact">
        <dt>Job title</dt>
        <dd>{{ profile.jobTitle }}</dd>
      </div>
      <div class="fact">
        <dt>Location</dt>
        <dd>{{ profile.location }}</dd>
      </div>
      <div class="fact">
        <dt>Pronouns</dt>
        <dd>{{ profile.pronouns }}</dd>
      </div>
      <div class="fact">
        <dt>Looking for</dt>
        <dd>{{ profile.lookingFor }}</dd>
      </div>
      <div class="fact">
        <dt>Zodiac</dt>
        <dd>{{ profile.zodiacSign }}</dd>
      </div>
    </dl>

    <div class="interests" *ngIf="profile.interests?.length">
      <div class="section-label">Interests</div>
      <mat-chip-set aria-label="Interests">
        <mat-chip *ngFor="let tag of profile.interests">{{ tag }}</mat-chip>
      </mat-chip-set>
    </div>

    <div class="anthem" *ngIf="profile.anthem as a">
      <div class="section-label">My anthem</div>
      <div class="anthem-row">
        <img class="anthem-art" [src]="a.albumCoverUrl" width="56" height="56" alt="" />
        <div class="anthem-meta">
          <div class="anthem-title">{{ a.title }}</div>
          <div class="anthem-artist">{{ a.artist }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions" *ngIf="isTop()">
    <button mat-fab extended color="warn" (click)="clickNope()">
      <mat-icon>close</mat-icon>
      Nope
    </button>
    <button mat-fab extended color="accent" class="super-like" (click)="clickSuperLike()">
      <mat-icon>star</mat-icon>
      Super Like
    </button>
    <button mat-fab extended color="primary" (click)="clickLike()">
      <mat-icon>favorite</mat-icon>
      Like
    </button>
  </div>
</mat-card>
